@if (isOpen()) {
  <section class="help-panel surface-card shadow-4" aria-label="Central de Ajuda">
    <header class="help-header">
      <div class="flex align-items-center gap-2 min-w-0">
        <span class="help-avatar">
          <i class="pi pi-comments"></i>
        </span>
        <span class="flex flex-column min-w-0">
          <strong>Central de Ajuda</strong>
        </span>
      </div>
      <div class="flex align-items-center gap-1">
        @if (step() !== 'start') {
          <button type="button" class="icon-button" title="Recomeçar" (click)="reset()">
            <i class="pi pi-refresh"></i>
          </button>
        }
        <button type="button" class="icon-button" title="Fechar" (click)="close()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </header>

    <div class="help-body">
      <div class="bot-message">
        @switch (step()) {
          @case ('start') {
            <span>Selecione a opção que melhor descreve sua dúvida:</span>
          }
          @case ('faqAnswer') {
            <span>{{ selectedFaq()?.question }}</span>
          }
          @case ('supportType') {
            <span>Certo. Qual tipo de suporte você precisa?</span>
          }
          @case ('technical') {
            <span>Qual parte técnica da plataforma precisa de ajuda?</span>
          }
          @case ('platformContact') {
            <span>Esse assunto é com o suporte da plataforma. Escolha um canal:</span>
          }
          @case ('eventProblem') {
            <span>Escolha o assunto para direcionarmos corretamente:</span>
          }
          @case ('eventPicker') {
            <span>Sobre qual evento você quer falar?</span>
          }
          @case ('organizerContact') {
            <span>Contato disponível para esse evento:</span>
          }
        }
      </div>

      @if (step() === 'start') {
        <div class="option-list">
          @for (faq of quickFaqs; track faq.question) {
            <button type="button" class="option-row" (click)="openFaq(faq)">
              <i [class]="faq.icon"></i>
              <span>
                <strong>{{ faq.question }}</strong>
              </span>
            </button>
          }

          <button type="button" class="option-row support-choice" (click)="goTo('supportType')">
            <i class="pi pi-headphones"></i>
            <span>
              <strong>Falar com o suporte</strong>
              <small>Escolher entre evento ou problema técnico.</small>
            </span>
          </button>
        </div>
      }

      @if (step() === 'faqAnswer') {
        @if (selectedFaq(); as faq) {
          <div class="answer-card">
            <p>{{ faq.answer }}</p>
          </div>
        }

        <button type="button" class="option-row support-choice" (click)="goTo('supportType')">
          <i class="pi pi-headphones"></i>
          <span>
            <strong>Falar com o suporte</strong>
            <small>Continuar para atendimento.</small>
          </span>
        </button>

        <button type="button" class="back-button" (click)="goTo('start')">
          <i class="pi pi-arrow-left"></i>
          Voltar
        </button>
      }

      @if (step() === 'supportType') {
        <div class="option-grid">
          @for (option of supportTypeOptions; track option.label) {
            <button type="button" class="option-card" (click)="goTo(option.next)">
              <i [class]="option.icon"></i>
              <span>
                <strong>{{ option.label }}</strong>
                <small>{{ option.description }}</small>
              </span>
            </button>
          }
        </div>
        <button type="button" class="back-button" (click)="goTo('start')">
          <i class="pi pi-arrow-left"></i>
          Voltar
        </button>
      }

      @if (step() === 'technical') {
        <div class="option-list">
          @for (option of technicalOptions; track option.label) {
            <button type="button" class="option-row" (click)="goTo(option.next)">
              <i [class]="option.icon"></i>
              <span>
                <strong>{{ option.label }}</strong>
                <small>{{ option.description }}</small>
              </span>
            </button>
          }
        </div>
        <button type="button" class="back-button" (click)="goTo('supportType')">
          <i class="pi pi-arrow-left"></i>
          Voltar
        </button>
      }

      @if (step() === 'platformContact') {
        <div class="option-list">
          <a class="contact-row" [href]="platformWhatsApp" target="_blank" rel="noopener">
            <i class="pi pi-whatsapp"></i>
            <span>
              <strong>WhatsApp</strong>
              <small>(34) 9 9946-9600</small>
            </span>
          </a>
          <a class="contact-row" [href]="'mailto:' + platformEmail">
            <i class="pi pi-envelope"></i>
            <span>
              <strong>E-mail</strong>
              <small>{{ platformEmail }}</small>
            </span>
          </a>
        </div>
        <button type="button" class="back-button" (click)="goTo('supportType')">
          <i class="pi pi-arrow-left"></i>
          Voltar
        </button>
      }

      @if (step() === 'eventProblem') {
        <div class="option-list">
          @for (option of eventOptions; track option.label) {
            <button type="button" class="option-row" (click)="goTo(option.next)">
              <i [class]="option.icon"></i>
              <span>
                <strong>{{ option.label }}</strong>
                <small>{{ option.description }}</small>
              </span>
            </button>
          }
        </div>
        <button type="button" class="back-button" (click)="goTo('supportType')">
          <i class="pi pi-arrow-left"></i>
          Voltar
        </button>
      }

      @if (step() === 'eventPicker') {
        <form class="event-search" role="search" (submit)="searchEvents($event)">
          <input
            type="text"
            placeholder="Buscar evento"
            name="eventSearch"
            autocomplete="off"
            enterkeyhint="search"
            inputmode="search"
            [ngModel]="eventSearch()"
            (ngModelChange)="eventSearch.set($event)" />
          <button type="submit" class="event-search-button" aria-label="Buscar evento">
            <i class="pi pi-search"></i>
          </button>
        </form>

        @if (eventSearch().trim()) {
          <button type="button" class="event-search-suggestion" (click)="searchEvents()">
            <i class="pi pi-search"></i>
            <span>Buscar "{{ eventSearch().trim() }}"</span>
          </button>
        }

        @if (loadingEvents()) {
          <div class="empty-state">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Buscando eventos...</span>
          </div>
        } @else if (visibleEvents().length > 0) {
          <div class="event-list">
            @for (event of visibleEvents(); track event.id) {
              <button type="button" class="event-row" (click)="selectEvent(event)">
                <span>
                  <strong>{{ event.name }}</strong>
                  <small>{{ formatEventMeta(event) }}</small>
                </span>
                <i class="pi pi-chevron-right"></i>
              </button>
            }
          </div>
          @if (visibleEvents().length < events().length) {
            <button type="button" class="more-button" (click)="showMoreEvents()">
              Ver mais eventos
            </button>
          }
        } @else {
          <div class="empty-state">
            <i class="pi pi-info-circle"></i>
            <span>
              @if (searchedTerm()) {
                Nenhum evento encontrado para "{{ searchedTerm() }}".
              } @else {
                Nenhum evento disponível agora.
              }
            </span>
          </div>
        }

        <button type="button" class="back-button" (click)="goTo('eventProblem')">
          <i class="pi pi-arrow-left"></i>
          Voltar
        </button>
      }

      @if (step() === 'organizerContact') {
        @if (loadingContact()) {
          <div class="empty-state">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Buscando contato...</span>
          </div>
        } @else if (selectedContact(); as contact) {
          <div class="organizer-card">
            <strong>{{ contact.eventName }}</strong>
            <small>Organizador: {{ contact.organizerName || 'não informado' }}</small>

            @if (contact.phone || contact.email) {
              <div class="option-list mt-2">
                @if (contact.phone) {
                  <a class="contact-row" [href]="whatsappLink(contact.phone)" target="_blank" rel="noopener">
                    <i class="pi pi-whatsapp"></i>
                    <span>
                      <strong>WhatsApp/Telefone</strong>
                      <small>{{ contact.phone }}</small>
                    </span>
                  </a>
                }
                @if (contact.email) {
                  <a class="contact-row" [href]="'mailto:' + contact.email">
                    <i class="pi pi-envelope"></i>
                    <span>
                      <strong>E-mail</strong>
                      <small>{{ contact.email }}</small>
                    </span>
                  </a>
                }
              </div>
            } @else {
              <div class="empty-state warning">
                <i class="pi pi-info-circle"></i>
                <span>Contato direto não publicado para esse evento.</span>
              </div>
            }
          </div>
        }

        <button type="button" class="back-button" (click)="goTo('eventPicker')">
          <i class="pi pi-arrow-left"></i>
          Escolher outro evento
        </button>
      }
    </div>
  </section>
}

<button
  type="button"
  class="help-fab"
  [class.is-open]="isOpen()"
  [attr.aria-expanded]="isOpen()"
  aria-label="Abrir ajuda"
  (click)="toggle()">
  <i class="pi" [class.pi-comments]="!isOpen()" [class.pi-times]="isOpen()"></i>
</button>
